import Tooltip from "@codegouvfr/react-dsfr/Tooltip";
import React from 'react';
import { useFormContext } from 'react-hook-form';
import {FaCircleInfo} from "react-icons/fa6";
import { ZodError } from 'zod';

export const SelectField = ({
                              name,
                              title,
                              value,
                              options,
                              className,
                              disabled,
                              onSelect,
                              tooltip,
                            }: SelectFieldProps) => {
  const { register, formState, schema } = useFormContext();

  if (!schema.shape[name]) throw new ZodError(`Missing key '${name}' from validation schema passed in Form component.`);

  const inputProps = register(name);
  const error = formState.errors[name];
  const required = !schema.shape[name].isOptional();

  return (
    <div className={'form-field ' + className}>
      {(title) && (
        <label className={'flex gap-1'} htmlFor={name}>
          {title} {required && <label>*</label>}
          {(tooltip) && (
            <Tooltip title={tooltip!} kind="hover">
              <FaCircleInfo className={'color-primary'}/>
            </Tooltip>
          )}
        </label>
      )}
      {error?.message && <span className={'error-message'}>{error?.message}</span>}

      <select
        {...inputProps}
        id={`input-${name}`}
        className={'form-field-input'}
        disabled={!!disabled}
        style={{ backgroundColor: disabled ? '#eaeaea' : '' }}
        {...(value != null ? { value } : {})}
        onChange={(e) => {
          onSelect?.(e.target.value);
          inputProps.onChange(e).then();
        }}
      >
        {options.map(({ label, value }, index) => (
          <option key={`${index}-${value}`} value={value}>{label}</option>
        ))}
      </select>
    </div>
  );
};

interface SelectFieldProps {
  name: string;
  options: SelectOption[];
  title?: string;
  value?: string;
  disabled?: boolean;
  className?: string;
  onSelect?: (value: string) => void;
  tooltip?: string;
}

export interface SelectOption {
  label: string;
  value: string;
}
